import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setIsAuthenticated } from 'src/redux/auth.slice';

import Loader from '../../components/Loader';
import { ROUTES } from '../../constants/routes';
import { verifyCode } from '../../services/AuthService';

const Callback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        let data = {
            code: searchParams.get('code'),
            state: searchParams.get('state'),
            verifier: localStorage.getItem('verifier'),
        } as any;

        if (data.code && data.state && data.verifier) {
            verifyCode(data)
                .then((response: any) => {
                    // WAL internal user with portal access — the selection token is already stored
                    // by verifyCode; send them to the customer selection screen (not authenticated yet).
                    if (response?.requiresCustomerSelection) {
                        navigate(ROUTES.LOGIN, {
                            replace: true,
                            state: { showCustomerSelection: true },
                        });
                    } else if (response?.token) {
                        dispatch(setIsAuthenticated(true));
                        navigate(ROUTES.HOME);
                    } else {
                        navigate(ROUTES.LOGIN, {
                            replace: true,
                            state: {
                                error: response?.message || t('Auth.Error.Microsoft_Auth_Error'),
                            },
                        });
                    }
                })
                .catch((error: any): any => {
                    navigate(ROUTES.LOGIN, {
                        replace: true,
                        state: {
                            error: error?.response?.data?.message || t('Auth.Error.Microsoft_Auth_Error'),
                        },
                    });
                })
                .finally(() => localStorage.removeItem('verifier'));
        } else {
            navigate(ROUTES.LOGIN, {
                replace: true,
                state: {
                    error: t('Auth.Error.Microsoft_Auth_Error'),
                },
            });
        }
    }, []);

    return <Loader />;
};

export default Callback;
